//https://www.patterns.dev/posts/observer-pattern

type Observer<TData> = (__data: TData) => void;

class ObserverFactory<TData = any> {
  private observers: Observer<TData>[];

  constructor() {
    this.observers = [];
  }

  subscribe(f: Observer<TData>): () => void {
    this.observers.push(f);
    return () => this.unsubscribe(f);
  }

  unsubscribe(f: Observer<TData>) {
    this.observers = this.observers.filter((observer) => observer !== f);
  }

  notify(data: TData) {
    this.observers.forEach((observer) => observer(data));
  }
}

export default ObserverFactory;
